import React, { createContext, useContext, useState, useEffect } from 'react';
import { db, getProWhitelist } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import { getPlanConfig, isWhitelisted } from '../utils/planUtils';

const PlanContext = createContext();

export const usePlan = () => useContext(PlanContext);

export function PlanProvider({ children, uid, email }) {
  const [planKey, setPlanKey] = useState('core');
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [planLoading, setPlanLoading] = useState(true);
  const [whitelistEmails, setWhitelistEmails] = useState([]);

  // Load whitelist once
  useEffect(() => {
    getProWhitelist().then(emails => setWhitelistEmails(emails || [])).catch(() => {});
  }, []);

  // Real-time listener on user doc — picks up webhook plan updates instantly
  useEffect(() => {
    if (!uid) {
      setPlanKey('core');
      setPlanLoading(false);
      return;
    }

    const unsub = onSnapshot(doc(db, 'users', uid), (snap) => {
      const data = snap.data();
      if (isWhitelisted(email, whitelistEmails)) {
        setPlanKey('pro');
      } else {
        setPlanKey(data?.plan || 'core');
      }
      setBillingCycle(data?.billingCycle || 'monthly');
      setPlanLoading(false);
    }, () => {
      setPlanKey('core');
      setPlanLoading(false);
    });

    return () => unsub();
  }, [uid, email, whitelistEmails]);

  const planConfig = getPlanConfig(planKey);
  const isPro = planKey === 'pro';

  const isFeatureEnabled = (featureName) => {
    return !!planConfig[featureName];
  };

  const value = {
    planKey,
    billingCycle,
    planConfig,
    isPro,
    planLoading,
    isFeatureEnabled,
  };

  return (
    <PlanContext.Provider value={value}>
      {children}
    </PlanContext.Provider>
  );
}
